export class DygraphInteractionModel {
    constructor(
        private Dygraph: any,
        private updateZoom: any,
        private unhighlightPointer: any,
    ) {}

    mouseDown(event, g, context) {
        context.initializeMouseDown(event, g, context);
        this.Dygraph.startZoom(event, g, context);
    }

    mouseMove(event, g, context) {
        this.Dygraph.moveZoom(event, g, context);
    }

    mouseUp(event, g, context) {
        if (context.dragDirection !== 2) {
            const startDate = g.dateWindow_[0];
            this.Dygraph.endZoom(event, g, context);
            const newMinX = Math.abs((startDate - g.dateWindow_[0]) / 1000);
            const dateWindow = (g.dateWindow_[1] - g.dateWindow_[0]) / 1000;
            const newMaxX = newMinX + dateWindow;
            this.updateZoom(Math.round(newMinX), Math.round(newMaxX));
        } else {
            g.clearZoomRect_();
            context.isZooming = false;
            context.dragStartX = null;
            context.dragStartY = null;
        }
    }

    touchStart(event, g, context) {
        this.unhighlightPointer();
    }

    touchMove(event, g, context) {
        const touchEvent = event.touches[0];
        if (!context.isZooming) {
            context.initializeMouseDown(touchEvent, g, context);
            this.Dygraph.startZoom(touchEvent, g, context);
        } else {
            this.Dygraph.moveZoom(touchEvent, g, context);
        }
    }

    touchEnd(event, g, context) {
        if (context.isZooming && context.dragDirection !== 2) {
            const startDate = g.dateWindow_[0];
            const touchEvent = event.changedTouches[0];
            this.Dygraph.endZoom(touchEvent, g, context);
            const newMinX = Math.abs((startDate - g.dateWindow_[0]) / 1000);
            const dateWindow = (g.dateWindow_[1] - g.dateWindow_[0]) / 1000;
            const newMaxX = newMinX + dateWindow;
            this.updateZoom(Math.round(newMinX), Math.round(newMaxX));
        } else {
            g.clearZoomRect_();
            context.isZooming = false;
            context.dragStartX = null;
            context.dragStartY = null;
        }
    }
}
